import { render, staticRenderFns } from "./ContactAddressILP.vue?vue&type=template&id=72c33087&scoped=true&"
import script from "./ContactAddressILP.vue?vue&type=script&lang=js&"
export * from "./ContactAddressILP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c33087",
  null
  
)

export default component.exports